import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'urlAddDomain'
})
export class UrlAddDomainPipe implements PipeTransform {

  public transform(value: string): string {
    const instanceDomain: string = sessionStorage.getItem("$instance_domain");
    return instanceDomain ?
        `https://${instanceDomain}/${value}` :
        value;
  }

}
